import React from 'react';
import './NavButton.css';

var NavButton = function NavButton(_ref) {
  var children = _ref.children,
      text = _ref.text,
      premium = _ref.premium;
  return React.createElement("span", {
    className: "NavButton"
  }, children, premium ? React.createElement("span", {
    className: "premium"
  }, " Premium ") : '', React.createElement("span", {
    className: "text"
  }, text));
};

NavButton.defaultProps = {
  premium: false
};
export default NavButton;